import { render, staticRenderFns } from "./Userapp.vue?vue&type=template&id=bd1a6cbe&"
import script from "./Userapp.vue?vue&type=script&lang=js&"
export * from "./Userapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports